export const GET_MAX_PROMOCODE_AMT = "GET_MAX_PROMOCODE_AMT";
export type GET_MAX_PROMOCODE_AMT = typeof GET_MAX_PROMOCODE_AMT;

export const GET_MAX_PROMOCODE_AMT_SUCCESS = "GET_MAX_PROMOCODE_AMT_SUCCESS";
export type GET_MAX_PROMOCODE_AMT_SUCCESS = typeof GET_MAX_PROMOCODE_AMT_SUCCESS;

export const GET_MAX_PROMOCODE_AMT_FAILURE = "GET_MAX_PROMOCODE_AMT_FAILURE";
export type GET_MAX_PROMOCODE_AMT_FAILURE = typeof GET_MAX_PROMOCODE_AMT_FAILURE;
